/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { IFile } from '@awesome-cordova-plugins/file/ngx';

@Injectable({
  providedIn: 'root',
})
export class FileReaderService {
  readAsArrayBuffer(file: IFile): Promise<Blob> {
    return new Promise<Blob>((resolve, reject) => {
      const reader = this.getFileReader();
      reader.onload = () =>
        resolve(new Blob([reader.result!], { type: file.type }));
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsArrayBuffer(file);
    });
  }

  readAsDataURL(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = this.getFileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(blob);
    });
  }

  //https://github.com/ionic-team/capacitor/issues/1564
  private getFileReader(): FileReader {
    const fileReader = new FileReader();
    const zoneOriginalInstance = (fileReader as any)[
      // eslint-disable-next-line @typescript-eslint/dot-notation
      '__zone_symbol__originalInstance'
    ];
    return zoneOriginalInstance || fileReader;
  }
}
